import React from 'react';
import Meta from './../components/Meta';
import AdminApplySection from './../components/AdminApply/AdminApplySection';

function AdminApplyPage() {
  return (
    <>
      <Meta title="Request Access" />
      <AdminApplySection />
    </>
  );
}

export default AdminApplyPage;
